export class ApiUtility {
  public static readonly personaManagementPrefix = `concourse/v1/`;
}
